module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/super-touch-video-en-mobile.e5df3de5.mp4";